import React from 'react';
import ProductDownloadBrochures from '../@shared/productDownloadBrochures';
import { descriptionKeyModelBrochure, eyebrowKeyModelBrochure, titleKeyModelBrochure } from '../../constants/dictionary.constants';

const ProductModelDetailDownloadBrochures = (props): JSX.Element => {
  return (
    <>
      <ProductDownloadBrochures
        {...props}
        eyebrowDictionaryKeyBrochure={eyebrowKeyModelBrochure}
        titleDictionaryKeyBrochure={titleKeyModelBrochure}
        descriptionDictionaryKeyBrochure={descriptionKeyModelBrochure}
      />
    </>
  );
};

export default ProductModelDetailDownloadBrochures;
